export default "__VITE_ASSET__C$mT56vg__"